// @ts-nocheck

import { type BasketState } from '../../../states/basket';
import { type GenericAction } from '../../../types/redux';

const basketUpdateItemIsFromMultichoice = (state: BasketState, action: GenericAction): BasketState => {
  const { payload } = action;
  const { oddId, isFromMultichoice } = payload ?? {};

  return {
    ...state,
    items: {
      ...state.items,
      [oddId]: {
        ...state.items[oddId],
        isFromMultichoice,
      },
    },
  };
};

export default basketUpdateItemIsFromMultichoice;
